// Get CSRF token from cookies
export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

// Refresh CSRF token
export async function refreshCSRFToken() {
  try {
    const response = await fetch('/api/csrf/restore', {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Failed to refresh CSRF token');
    }

    // The token will be automatically set in cookies by the backend
    return true;
  } catch (error) {
    console.error('Error refreshing CSRF token:', error);
    throw error;
  }
}

// Check if an error is related to CSRF token
export function isCSRFTokenError(error) {
  if (!error) return false;

  const errorMessage = error.message || error.toString();
  return errorMessage.toLowerCase().includes('csrf') ||
         errorMessage.toLowerCase().includes('token') ||
         errorMessage.toLowerCase().includes('session expired');
}
